import { DestroyRef, inject, Injector, runInInjectionContext } from "@angular/core";
import { CrudService } from './crud.service';
import { SingleCrudService } from './single-crud.service';
import { CrudQueryBuilder } from '@core/shared/crud';
import * as i0 from "@angular/core";
;
export function crudServiceFactoryFacade(inj) {
  return {
    createCrudService(Model, query) {
      return runInInjectionContext(inj, () => {
        // @ts-ignore - allowed way to create final CrudService
        const inst = new CrudService(query || new CrudQueryBuilder());
        inst.setModel(Model);
        return inst;
      });
    },
    createSingleCrudService(Model) {
      return runInInjectionContext(inj, () => {
        const inst = new SingleCrudService();
        inst.setModel(Model);
        return inst;
      });
    },
    // WARNING: Use only for testing! CrudService is considered final and must not be extended.
    create(ClassCtor, query) {
      return runInInjectionContext(inj, () => {
        return new ClassCtor(query || new CrudQueryBuilder());
      });
    }
  };
}
export let CrudServiceFactory = /*#__PURE__*/(() => {
  class CrudServiceFactory {
    constructor() {
      this.inj = inject(Injector);
    }
    useDestroyRef(destroyRef) {
      return crudServiceFactoryFacade(Injector.create({
        providers: [{
          provide: DestroyRef,
          useValue: destroyRef
        }],
        parent: this.inj
      }));
    }
    static {
      this.ɵfac = function CrudServiceFactory_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CrudServiceFactory)();
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: CrudServiceFactory,
        factory: CrudServiceFactory.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return CrudServiceFactory;
})();